import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Grid from 'material-ui/Grid'

import HomeBanner from '../components/HomeBanner'

// NOTE available sections
import ActionSection1 from '../components/sections/ActionSection1'
import InfoSection1 from '../components/sections/InfoSection1'
import ListSection from '../components/sections/ListSection'
import VideoSection1 from '../components/sections/VideoSection1'
import VideoSection2 from '../components/sections/VideoSection2'

import * as SiteConfig from '../config/Config'

class IndexPage extends Component {
  render(){

    let renderSection = SiteConfig.pages.home.sections &&  SiteConfig.pages.home.sections.length !== 0
      ?
      SiteConfig.pages.home.sections.map((section, index) => {
        switch (section.component) {
          case "ActionSection1":
            return (<ActionSection1
              key={index}
              isFullScreen={section.isFullScreen}
              title={section.title}
              description={section.description}
              image={section.image}
              altText={section.altText}
              buttonURL={section.buttonURL}
              buttonText={section.buttonText}
              direction={section.direction}
            />)
          case "InfoSection1":
            return (<InfoSection1
              key={index}
              isFullScreen={section.isFullScreen}
              title={section.title}
              subTitle={section.subTitle}
              descHeading={section.descHeading}
              description={section.description}
              direction={section.direction}
              image={section.image}
              altText={section.altText}
            />)
          case "ListSection":
            return (<ListSection
              key={index}
              isFullScreen={section.isFullScreen}
              title={section.title}
              subTitle={section.subTitle}
              listItems={section.items}
            />)
          case "VideoSection1":
            return (<VideoSection1
              key={index}
              isFullScreen={section.isFullScreen}
              title={section.title}
              subTitle={section.subTitle}
              description={section.description}
              videoId={section.videoId}
            />)
          case "VideoSection2":
            return (<VideoSection2
              key={index}
              isFullScreen={section.isFullScreen}
              title={section.title}
              subTitle={section.subTitle}
              descHeading={section.descHeading}
              description={section.description}
              videoId={section.videoId}
              direction={section.direction}
            />)
          default:
            return null;
        }
      })
      :
      (<div style={{ padding: '100px 0' }}> <h1>NO sections</h1> </div>)

    const {
      data
    } = this.props

    return (
      <Grid
        container
        spacing={0}
        justify="center"
      >
      
        {/* <Helmet
          title={data.site.siteMetadata.pages.home.meta.title}
          meta={[
            { name: 'description', content: `${data.site.siteMetadata.pages.home.meta.description}` },
            { name: 'keywords', content: `${data.site.siteMetadata.pages.home.meta.keywords.map(keyword => keyword)}` },
          ]}
        /> */}
        <Helmet
          title={SiteConfig.pages.home.meta.title}
          meta={[
            { name: 'description', content: `${SiteConfig.pages.home.meta.description}` },
            { name: 'keywords', content: `${SiteConfig.pages.home.meta.keywords.map(keyword => keyword)}` },
          ]}
        />

        <HomeBanner
          title={SiteConfig.pages.home.banner.title}
          subTitle={SiteConfig.pages.home.banner.subTitle}
          action={SiteConfig.pages.home.banner.action}
        />

        {renderSection}

      </Grid>
    )
  }
}

export default IndexPage

// export const query = graphql`
//   query HomeQuery {
//   site {
//     siteMetadata {
//       pages {
//         home {
//           meta {
//             title
//             description
//             keywords
//           }
//         }
//       }
//     }
//   }
// }
// `;


// WEBPACK FOOTER //
// ./src/pages/index.js